module.exports = __webpack_public_path__ + "media/images/mobile/city_img/g4-99f743924955182b46d0f7a0e124c6eb.png";